<template>
  <div class="fts-formula-switch">
    <fts-input-group>
      <fts-formula
        :variables="variables"
        v-model="mutableValue.formula"
        ref="formulaControl"
        class="formula-control"
        v-if="isFormula"
      />
      <slot v-else>
        <input
          type="text"
          class="fts-form-control"
          autocomplete="formula-switch-input"
          v-model="mutableValue"
        />
      </slot>
      <template #append v-if="!disabledToggle">
        <fts-input-group-icon
          :active="isFormula"
          @click.native="toggleFormula"
        >
          <i class="fts-icon-formula"></i>
        </fts-input-group-icon>
      </template>
    </fts-input-group>
  </div>
</template>

<script>
import FTSFormula from './FTSFormula';
import FTSInputGroup from '../elements/input-group/FTSInputGroup';
import FTSInputGroupIcon from '../elements/input-group/FTSInputGroupIcon';

export default {
  components: {
    'fts-formula': FTSFormula,
    'fts-input-group': FTSInputGroup,
    'fts-input-group-icon': FTSInputGroupIcon
  },
  props: {
    variables: Array,
    value: {
      required: true
    },
    disabledToggle: Boolean,
    defaultValue: {
      default: null
    },
    formulaDefaultValue: {
      default: null
    }
  },
  model: {
    prop: "value",
    event: "updateValue"
  },
  methods: {
    toggleFormula() {
      if (!this.disabledToggle) {
        if (this.isFormula) {
          this.mutableValue = this.defaultValue;
        } else {
          this.mutableValue = { formula: this.formulaDefaultValue };
        }
      }
    }
  },
  computed: {
    mutableValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("updateValue", val);
        this.$emit("input", val);
      }
    },
    isFormula() {
      return Boolean(this.mutableValue && this.mutableValue.hasOwnProperty("formula"));
    }
  }
}
</script>

<style lang="scss" scoped>
@use "./src/assets/scss/vars" as *;

.fts-formula-switch {
  .formula-control {
    width: 100%;
    font-size: $font-size;
    line-height: $line-height;
  }
}
</style>